import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Aprender más rápido', 'Recordar sin esfuerzo', 'Mejorar concentración', 'Estudiar menos y rendir más'];
  return <section className="py-24 relative overflow-hidden" data-id="element-12">
      {/* Decorative background element */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-cerebro-blue/5 rounded-full blur-[100px] -z-10" data-id="element-13" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-15">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-16">
            Lo que vas a lograr
          </h2>
          <div className="w-24 h-1 bg-cyan-400 mx-auto rounded-full shadow-[0_0_10px_rgba(34,211,238,0.5)]" data-id="element-17"></div>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-18">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -30 : 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="glass-card p-6 flex items-center gap-4 hover:bg-slate-800/60 transition-colors" data-id="element-19">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-cerebro-blue/20 flex items-center justify-center" data-id="element-20">
                <CheckCircle2 className="w-6 h-6 text-cerebro-blue" data-id="element-21" />
              </div>
              <span className="text-xl font-medium text-slate-200" data-id="element-22">
                {benefit}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}